import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import BagIcon from '@buncha/components/core/icon/BagIcon';
import {Box} from '@buncha/components/core/view';
import {H2Text} from '@buncha/components/core/text';
import React from 'react';
import {styles} from './styles';

interface EmptyOrdersProps {
  bottomText: string;
}

const EmptyOrders: React.FC<EmptyOrdersProps> = props => {
  const {bottomText} = props;
  const theme = useColorThemeType();
  const mortiseFont = useFontTheme('mortise');
  return (
    <Box style={styles.parentContainer}>
      <BagIcon height={200} width={200} viewBox="-35 -25 190 190" />
      <H2Text
        numberOfLines={2}
        style={[
          styles.textStyle,
          {
            color: theme?.text?.blue[300],
            fontFamily: mortiseFont[700].normal,
          },
        ]}>
        {bottomText}
      </H2Text>
    </Box>
  );
};

export default React.memo(EmptyOrders);
